import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ScrollToTop from "./ScrollToTop";
import Layout from "./layout";
import Home from "./Pages/home";
import Articles from "./Pages/articles";
import Article from "./Pages/article";
import Founders from "./Pages/founders";
import Terms from "./Pages/terms";
import Contact from "./Pages/contact";
import Support from "./Pages/support";
import Admin from "./Pages/admin";
import Privacy from "./Pages/privacy";
import FeaturesTest from "./Pages/features-test";
import HomeSimple from "./Pages/home-simple";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route
            path="/"
            element={
              <Layout currentPageName="Home">
                <Home />
              </Layout>
            }
          />
          <Route
            path="/home"
            element={
              <Layout currentPageName="Home">
                <Home />
              </Layout>
            }
          />
          <Route
            path="/articles"
            element={
              <Layout currentPageName="Articles">
                <Articles />
              </Layout>
            }
          />
          <Route
            path="/article"
            element={
              <Layout currentPageName="Article">
                <Article />
              </Layout>
            }
          />
          <Route
            path="/founders"
            element={
              <Layout currentPageName="Founders">
                <Founders />
              </Layout>
            }
          />
          <Route
            path="/terms"
            element={
              <Layout currentPageName="Terms">
                <Terms />
              </Layout>
            }
          />
          <Route
            path="/privacy"
            element={
              <Layout currentPageName="Privacy">
                <Privacy />
              </Layout>
            }
          />
          <Route
            path="/contact"
            element={
              <Layout currentPageName="Contact">
                <Contact />
              </Layout>
            }
          />
          <Route
            path="/support"
            element={
              <Layout currentPageName="Support">
                <Support />
              </Layout>
            }
          />
          <Route
            path="/admin"
            element={
              <Layout currentPageName="Admin">
                <Admin />
              </Layout>
            }
          />
          <Route
            path="/features-test"
            element={
              <Layout currentPageName="Features Test">
                <FeaturesTest />
              </Layout>
            }
          />
          <Route
            path="/simple"
            element={
              <Layout currentPageName="Home">
                <HomeSimple />
              </Layout>
            }
          />
          {/* Catch-all route for 404 handling */}
          <Route
            path="*"
            element={
              <Layout currentPageName="Home">
                <Home />
              </Layout>
            }
          />
        </Routes>
      </Router>
    </QueryClientProvider>
  );
}

export default App;

